import { IHPContact } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { getSeparatedPhone } from 'legacy/lut/components/widgets/public/phoneEditor/helpers/getSeparatedPhone'

export const getHPContactPhone = (contact: IHPContact) => {
  return getSeparatedPhone({
    phone: contact.MainPhoneNorm || contact.MobilePhoneNorm || '',
  })
}
